import React from "react";
import styled from '@emotion/styled';
import HomeImage from "../assets/images/CNC-Home.png";
import logoCapa from "../assets/logos/capacitacion-logo.png";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const HomeSection = () => {
  const navigate = useNavigate();

  const handleClick = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const ImgDiv = styled.div`
    background-image: url(${HomeImage});
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    width: 100%;
    height: 30em;
    display: flex;
    align-items: center;
  `;

  const BlackDiv = styled.div`
    background: linear-gradient(0.25turn, transparent, black, transparent);
    height: 70%;
    width: 100%;
    display: flex;
    padding: 0 20px;
    justify-content: space-between;
    align-items: center;
    z-index: 10;

    @media (max-width: 768px) {
      flex-direction: column;
      justify-content: center;
      text-align: center;
      gap: 1.5rem;
    }
  `;

  const Logo = styled.img`
    height: 150px;
    margin-right: 20px;
    margin-left: 10px;

    @media (max-width: 768px) {
      height: 100px;
      margin: 0 auto;
    }
  `;

  const DivLogo = styled.div`
    width: 30%;
    @media (max-width: 768px) {
      width: 100%;
    }
  `;

  const Title = styled.p`
    font-family: "League Gothic", serif;
    font-size: 80px;
    color: white;
    line-height: 80px;

    @media (max-width: 768px) {
      font-size: 40px;
      line-height: 45px;
    }
  `;

  const SubTitle = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: #12b854;
    font-weight: 700;
    letter-spacing: 1px;
    margin-top: -30px;
    position: relative;
    bottom: 50px;


    @media (max-width: 768px) {
      font-size: 10px;
      line-height: 15px;
      bottom: 0px;
    }
  `;

  const DivTitle = styled.div`
    width: 40%;
    margin-right: 80px;

    @media (max-width: 768px) {
      width: 100%;
      margin: 0;
    }
  `;

  const ButtonText = styled.p`
    font-family: "DM Sans", serif;
    color: black;
    font-size: 13px;
    margin: 0;
  `;

  const ButtonsContainer = styled.div`
    width: 20%;
    min-width: 200px;

    @media (max-width: 768px) {
      display: none;
    }
  `;

  const StyledButton = {
    backgroundColor: "#12b854",
    color: "white",
    height: "40px",
    borderRadius: "30px",
    "&:hover": {
      color: "white",
      backgroundColor: "#0d6834",
    },
    padding: "0px 30px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
  };

  return (
    <ImgDiv>
      <BlackDiv>
        <DivLogo>
          <Logo src={logoCapa} alt="Logo Capa" />
        </DivLogo>

        <DivTitle>
          <Title>CAPACITACIÓN NACIONAL</Title>
          <SubTitle>"SALVANDO VIDAS, CAMBIANDO MENTALIDADES"</SubTitle>
        </DivTitle>

        <ButtonsContainer>
          <Stack spacing={2} direction="column">
            <Button sx={StyledButton} onClick={() => handleClick("/Catalogo")}>
              <ButtonText>CATÁLOGO DIGITAL</ButtonText>
              <FaArrowRight color="black" />
            </Button>
            <Button sx={StyledButton} onClick={() => handleClick("/Sedes")}>
              <ButtonText>SEDES Y OFERTAS</ButtonText>
              <FaArrowRight color="black" />
            </Button>
            <Button sx={StyledButton} onClick={() => handleClick("/Certificados")}>
              <ButtonText>BUSCA TU CERTIFICADO</ButtonText>
              <FaArrowRight color="black" />
            </Button>
            <Button sx={StyledButton} onClick={() => handleClick("/Nosotros")}>
              <ButtonText>CONÓCENOS</ButtonText>
              <FaArrowRight color="black" />
            </Button>
          </Stack>
        </ButtonsContainer>
      </BlackDiv>
    </ImgDiv>
  );
};

export default HomeSection;
